import React from "react";
import InclusionListUI from "../InclusionList/InclusionListUI";
import ExtraChargesUI from "../ExtraCharges/ExtraChargesUI";
import * as S from "./InclusionExclusion.styles";

interface IinclusionExclusion {
  t: string;
  i_t: string;
  e_t: string;
  inclusion: Array<string>;
  exclusion: Array<string>;
}

const InclusionExclusionUI: React.FC<IinclusionExclusion> = ({
  t = '',
  i_t = '',
  e_t = '',
  inclusion = [],
  exclusion = []
}) => {
  return (
    <S.InclusionCont margin={"0 0 2rem 0"}>
      <S.InclusionHeader>
        <h3>{t}</h3>
      </S.InclusionHeader>
      <S.InclusionContent>
        {inclusion?.length ? (
          <div className="inclusionCol">
            <h4>{i_t}</h4>
            <InclusionListUI data={inclusion} />
          </div>
        ) : null}
        {exclusion?.length ? (
          <div className="inclusionCol">
            <h4>{e_t}</h4>
            <ExtraChargesUI data={exclusion} />
          </div>
        ) : null}
      </S.InclusionContent>
    </S.InclusionCont>
  );
};

export default React.memo(InclusionExclusionUI);
